module.exports = __webpack_public_path__ + "media/src/fonts/icofont-9c33516aab48c61e3081a1e5241fdd1e.woff2";